module.exports = __webpack_public_path__ + "img/banner.56c5dbb.png";